import { useMutation, useQueryClient } from '@tanstack/react-query';
import { lineItemService } from '@services/lineItem';
import { UpdateLineItemInput } from '@models/lineItem.model';
import { toast } from 'react-toastify';
import { PROJECT_BUDGET_SUMMARY_QUERY_KEY } from './useGetProjectBudgetSummary';
import { DISTINCT_LINE_ITEM_UOMS_QUERY_KEY } from './useGetDistinctUnitsOfMeasure';
import { AVAILABLE_BUDGET_ITEMS_QUERY_KEY } from '@hooks/api/invoice';
import { useTranslation } from '@hooks/useTranslation';

export const useUpdateLineItem = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: UpdateLineItemInput) => lineItemService.updateLineItem(input),
    onSuccess: () => {
      toast.success(tActionMessages.lineItemUpdated);
      queryClient.invalidateQueries({
        queryKey: [PROJECT_BUDGET_SUMMARY_QUERY_KEY],
        refetchType: 'active',
      });
      queryClient.invalidateQueries({
        queryKey: [DISTINCT_LINE_ITEM_UOMS_QUERY_KEY],
        refetchType: 'active',
      });
      queryClient.invalidateQueries({
        queryKey: [AVAILABLE_BUDGET_ITEMS_QUERY_KEY],
        refetchType: 'active',
      });
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.errors?.[0]?.message || error?.message || tActionMessages.errorUpdatingLineItem,
      );
    },
  });
};
